import { render } from "./membership-text.vue?vue&type=template&id=65f8462e&lang=pug"
import script from "./membership-text.vue?vue&type=script&setup=true&lang=js"
export * from "./membership-text.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__